export default __webpack_public_path__ + "static/media/icons.22c93d84.svg";